export default __webpack_public_path__ + "static/media/7minfitness_9.64afb672.jpg";